webpackJsonp([0],{

/***/ "./helpers/animation.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


function whichAnimationEvent() {
  var t = void 0,
      el = document.createElement('fakeelement');
  var animations = {
    animation: 'animationend',
    OAnimation: 'oAnimationEnd',
    MozAnimation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd' };
  for (var _t in animations) {
    if (el.style[_t] !== undefined) {
      return animations[_t];
    }
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (whichAnimationEvent());

/***/ }),

/***/ "./helpers/dom.js":
/***/ (function(module, exports) {



window.qs = document.querySelector.bind(document);
window.qsa = document.querySelectorAll.bind(document);
Element.prototype.on = Element.prototype.addEventListener;

/***/ }),

/***/ "./helpers/getCoords.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCoords;

function getCoords(elem) {
  var box = elem.getBoundingClientRect();
  return {
    'top': box.top + pageYOffset,
    'left': box.left + pageXOffset
  };
}

/***/ }),

/***/ "./helpers/target-blank.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("../node_modules/babel-runtime/helpers/toConsumableArray.js");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./helpers/dom.js
var dom = __webpack_require__("./helpers/dom.js");
var dom_default = /*#__PURE__*/__webpack_require__.n(dom);

// CONCATENATED MODULE: ./helpers/exists.js


/* harmony default export */ var exists = (function (selector) {
  return qsa(selector).length > 0;
});;
// CONCATENATED MODULE: ./helpers/target-blank.js




var base = window.location.hostname;
var assets = 'static.designdebut.ru';

[].concat(toConsumableArray_default()(qsa('\n  a[href^="http"]:not([href*="' + base + '"]):not([href*="' + assets + '"]),\n  a[href^="//"]:not([href*="' + base + '"]):not([href*="' + assets + '"])\n'))).forEach(function (item) {
  return item.setAttribute('target', '_blank');
});

if (exists('a[target="_blank"]')) {
  [].concat(toConsumableArray_default()(qsa('a[target="_blank"]'))).forEach(function (item) {
    window.opener = null;
    item.setAttribute('rel', 'nofollow noopener');
  });
}

/***/ }),

/***/ "./helpers/transition.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


function whichTransitionEvent() {
  var el = document.createElement('fakeelement');
  var transitions = {
    transition: 'transitionend',
    OTransition: 'oTransitionEnd',
    MozTransition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd' };
  for (var t in transitions) {
    if (el.style[t] !== undefined) {
      return transitions[t];
    }
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (whichTransitionEvent());

/***/ }),

/***/ "./main.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("../node_modules/babel-runtime/core-js/array/from.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_dom__ = __webpack_require__("./helpers/dom.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__helpers_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_target_blank__ = __webpack_require__("./helpers/target-blank.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_transition__ = __webpack_require__("./helpers/transition.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_animation__ = __webpack_require__("./helpers/animation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vendors_touch_action__ = __webpack_require__("./vendors/touch-action.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stickyfilljs__ = __webpack_require__("../node_modules/stickyfilljs/dist/stickyfill.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stickyfilljs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_stickyfilljs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_getCoords__ = __webpack_require__("./helpers/getCoords.js");


module.hot && module.hot.accept();

if (false) {
  console.log('%c Run development ' + VERSION + ' on ' + location.origin + ' ', 'background:tomato; color:white; display:block; padding:2px');
}







Object(__WEBPACK_IMPORTED_MODULE_5__vendors_touch_action__["a" /* touchAction */])();

var $html = qs('html');
var $body = qs('body');
var $app = qs('#app');
var $header = qs('.js-header');
var $headerNavTrigger = qs('.js-header-nav-trigger');
var $headerNav = qs('.js-header-nav');
var $headerNavItems = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(qsa('.js-header-nav ul a[href^="#"]'));

console.time('DOMContentLoaded');
document.addEventListener('DOMContentLoaded', function (e) {
  $html.classList.remove('is-loading');

  console.timeEnd('DOMContentLoaded');
});


var stickyEls = qsa('.sticky');
__WEBPACK_IMPORTED_MODULE_6_stickyfilljs___default.a.add(stickyEls);

__webpack_require__("../node_modules/smoothscroll-polyfill/dist/smoothscroll.js").polyfill();


var scrollToHash = function scrollToHash(hash) {
  if (!qs(hash)) return false;
  var offset = Object(__WEBPACK_IMPORTED_MODULE_7__helpers_getCoords__["a" /* getCoords */])(qs(hash)).top - $header.offsetHeight;

  window.scroll({
    top: offset,
    left: 0,
    behavior: 'smooth'
  });
};

window.addEventListener('load', function () {
  window.location.hash && scrollToHash(location.hash);
});

window.addEventListener('hashchange', function () {
  window.location.hash && scrollToHash(location.hash);
});

var headerNavState = function headerNavState(e) {
  e.preventDefault();
  if (window.matchMedia('(max-width: 767px)').matches) {
    console.log('matches');
    $html.classList.toggle('is-disabled');
    $html.classList.toggle('is-menu-open');
    $headerNavTrigger.classList.toggle('is-active');
    $headerNav.scrollTop = 0;
  }
};

$headerNavItems.forEach(function (target) {
  return target.on('click', function (e) {
    headerNavState(e);
    history.pushState(null, null, e.target.hash);
    scrollToHash(e.target.hash);
  });
});

$headerNavTrigger.on('click', function (e) {
  return headerNavState(e);
});

function debounce(cb, interval) {
  var timeout = void 0;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(cb.apply.bind(cb, this, arguments), interval);
  };
}

window.addEventListener('resize', debounce(function (e) {
  if (window.matchMedia('(min-width: 768px)').matches) {
    $html.classList.remove('is-disabled', 'is-menu-open');
    $headerNavTrigger.classList.remove('is-active');
    $headerNav.scrollTop = 0;
  }
}, 100));

(function () {
  var setActiveNavItem = function setActiveNavItem(id) {
    $headerNavItems.forEach(function (nav) {
      return nav.classList.remove('is-active');
    });
    $headerNavItems.filter(function (nav) {
      return nav.hash.slice(1) == id && nav.classList.add('is-active');
    });
  };

  var observer = new IntersectionObserver(function (changes) {
    return changes.forEach(function (change) {
      if (change.isIntersecting) {
        change.target.classList.add('in-view');
        setActiveNavItem(change.target.id);
      } else {
        change.target.classList.remove('in-view');
      }
    });
  }, { rootMargin: '-30% 0%' });

  var animations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(qsa('.l-section[id]'));
  animations.forEach(function (item) {
    return observer.observe(item);
  });
})();

qs('.js-goto-top').on('click', function (e) {
  e.preventDefault();
  window.scroll({ top: 0, left: 0, behavior: 'smooth' });
});

(function () {
  var observer = new IntersectionObserver(function (changes) {
    return changes.forEach(function (change) {
      var target = change.target;
      var dataSrc = target.dataset.src;
      if (change.isIntersecting) {
        var fake = new Image();
        fake.src = dataSrc;
        fake.onload = function () {
          target.src = dataSrc;
          target.classList.add('loaded');
          observer.unobserve(target);
        };
      }
    });
  }, { rootMargin: '50% 0px', threshold: 0.15 });

  var lazyImages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(qsa('[data-src]'));
  lazyImages.forEach(function (item) {
    return observer.observe(item);
  });
})();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../node_modules/webpack/buildin/harmony-module.js")(module)))

/***/ }),

/***/ "./styles/app.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./vendors/touch-action.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = touchAction;


function touchAction(opts) {
  var s;
  if (!opts) opts = {};
  if (!opts.src) opts.src = 'https://cdnjs.cloudflare.com/ajax/libs/fastclick/1.0.6/fastclick.min.js';
  if (!opts.val) opts.val = 'manipulation';

  if ('touchAction' in document.body.style) {
    document.body.style.touchAction = opts.val;
  } else {
    s = document.createElement('script');
    s.src = opts.src;
    s.async = true;
    s.onload = function onload() {
      window.FastClick.attach(document.body);
    };
    document.body.appendChild(s);
  }
}

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./styles/app.scss");
module.exports = __webpack_require__("./main.js");


/***/ })

},[0]);


// WEBPACK FOOTER //
// js/app.2f16b25.js